import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

function thumbUrl(url, size) {
  if (!url) return null;
  if (url.includes('/storage/v1/object/public/')) {
    const sep = url.includes('?') ? '&' : '?';
    return url + sep + 'width=' + size + '&height=' + size + '&resize=cover';
  }
  return url;
}

function ImageWithSkeleton({ src, alt, opacity }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%', height: 195 }}>
      {!loaded && <div className="card-img skeleton" style={{ position: 'absolute', inset: 0, height: 195 }} />}
      <img
        className="card-img"
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        style={{ opacity: loaded ? opacity : 0, transition: 'opacity .3s', position: 'absolute', inset: 0 }}
      />
    </div>
  );
}

const STATUS_LABELS = {
  available: 'Available',
  deposit_paid: 'Deposit Paid',
  sold: 'Sold',
};

export default function ListingCard({ listing }) {
  const navigate = useNavigate();
  const offerCount = listing.queue_entries?.[0]?.count || 0;
  const isUnavailable = listing.status === 'sold' || listing.status === 'deposit_paid';

  return (
    <div className="card" onClick={() => navigate(`/listing/${listing.id}`)}>
      <div style={{ position: 'relative' }}>
        {listing.image_url ? (
          <ImageWithSkeleton
            src={thumbUrl(listing.image_url, 400)}
            alt={listing.title}
            opacity={isUnavailable ? .55 : 1}
          />
        ) : (
          <div className="card-img-ph" style={{ opacity: isUnavailable ? .55 : 1 }}>🛍️</div>
        )}
        {isUnavailable && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ background: 'rgba(26,20,16,.72)', color: '#fff', fontWeight: 700, fontSize: '.8rem', padding: '.35rem .9rem', borderRadius: 20, letterSpacing: '.5px', textTransform: 'uppercase' }}>
              {listing.status === 'sold' ? 'Sold' : 'Deposit Paid'}
            </span>
          </div>
        )}
        {offerCount > 0 && !isUnavailable && (
          <div style={{ position: 'absolute', top: 8, right: 8, background: 'var(--terracotta)', color: '#fff', fontWeight: 700, fontSize: '.72rem', padding: '.2rem .6rem', borderRadius: 20, letterSpacing: '.3px' }}>
            {offerCount} {offerCount === 1 ? 'offer' : 'offers'}
          </div>
        )}
      </div>
      <div className="card-body">
        <div className="card-title">{listing.title}</div>
        <div className="card-price">${Number(listing.price).toFixed(2)}</div>
        <div className="card-meta">
          By <span
            style={{ color: 'var(--terracotta)', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
            onClick={e => { e.stopPropagation(); navigate(`/seller/${listing.profiles?.username}`); }}
          >{listing.profiles?.username || 'Seller'}</span>
          {listing.available_date && (
            <> · Avail. {format(new Date(listing.available_date), 'MMM d, yyyy')}</>
          )}
        </div>
        <div className="card-foot">
          <span className={`badge b-${listing.status}`}>
            {STATUS_LABELS[listing.status] || listing.status}
          </span>
          {offerCount > 0 && !isUnavailable && (
            <span style={{ fontSize: '.75rem', color: 'var(--terracotta)', fontWeight: 600 }}>
              {offerCount} {offerCount === 1 ? 'offer' : 'offers'} to buy
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
